import { render, staticRenderFns } from "./AssignRolePopupV2.vue?vue&type=template&id=0236eba4&scoped=true&"
import script from "./AssignRolePopupV2.vue?vue&type=script&lang=ts&"
export * from "./AssignRolePopupV2.vue?vue&type=script&lang=ts&"
import style0 from "./AssignRolePopupV2.vue?vue&type=style&index=0&id=0236eba4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0236eba4",
  null
  
)

/* custom blocks */
import block0 from "./AssignRolePopupV2.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports